import React from 'react'
import { useSelector } from 'react-redux'
import Route from './Route'
import RouteContext from './RouteContext'
import Loading from 'components/system/Loading'

import routerSelectors from 'store/selectors/router'

import Layout from 'pages/Layout'
import Home from 'pages/Home'
import NotFound from 'pages/NotFound'
import Help from 'pages/Help'


import AdminLogin from 'pages/admin/Login'
import AdminLogout from 'pages/admin/Logout'
import AdminRegister from 'pages/admin/Register'
import AdminSettings from 'pages/admin/Settings'
import AdminPayment from 'pages/admin/Payment'
import AdminLayout from 'pages/admin/Layout'
import AdminBookingForms from 'pages/admin/BookingForms'
import AdminUsers from 'pages/admin/Users'
import AdminProjects from 'pages/admin/Projects'
import AdminUpdateConfigs from 'pages/admin/UpdateConfigs'

import AdminBookingFormLayout from 'pages/admin/bookingform/Layout'
import AdminBookingFormConfig from 'pages/admin/bookingform/Config'
import AdminBookingFormCommunication from 'pages/admin/bookingform/Communication'
import AdminBookingFormWelcomePage from 'pages/admin/bookingform/WelcomePage'
import AdminBookingFormEmbed from 'pages/admin/bookingform/Embed'
import AdminBookingFormCalendar from 'pages/admin/bookingform/Calendar'
import AdminBookingFormSlot from 'pages/admin/bookingform/Slot'
import AdminBookingFormBooking from 'pages/admin/bookingform/Booking'
import AdminBookingFormSearch from 'pages/admin/bookingform/Search'
import AdminBookingFormSchedule from 'pages/admin/bookingform/Schedule'

import BookingForms from 'pages/book/BookingForms'

import BookingProjectWrapper from 'pages/book/ProjectWrapper'
import BookingFormLayout from 'pages/book/bookingform/Layout'
import BookingFormWelcome from 'pages/book/bookingform/WelcomePage'
import BookingFormCalendar from 'pages/book/bookingform/Calendar'
import BookingFormCustomize from 'pages/book/bookingform/Customize'
import BookingFormDetails from 'pages/book/bookingform/Details'
import BookingFormPayment from 'pages/book/bookingform/Payment'
import BookingFormConfirm from 'pages/book/bookingform/Confirm'

const Router = ({

}) => {
  const route = useSelector(routerSelectors.route)

  if(!route) {
    return (
      <Loading />
    )
  }

  return (
    <RouteContext.Provider value={ route.name }>
      <Layout>
        <Route segment="notfound" exact>
          <NotFound />
        </Route>
        <Route segment="home" exact>
          <Home />
        </Route>
        <Route segment="help" exact>
          <Help />
        </Route>
        <Route segment="book">
          <BookingProjectWrapper>
            <Route segment="list" exact>
              <BookingForms />
            </Route>
            <Route segment="form">
              <BookingFormLayout>
                <Route segment="start" exact>
                  <BookingFormWelcome />
                </Route>
                <Route segment="calendar" exact>
                  <BookingFormCalendar />
                </Route>
                <Route segment="customize" exact>
                  <BookingFormCustomize />
                </Route>
                <Route segment="details" exact>
                  <BookingFormDetails />
                </Route>
                <Route segment="payment" exact>
                  <BookingFormPayment />
                </Route>
                <Route segment="confirm" exact>
                  <BookingFormConfirm />
                </Route>
              </BookingFormLayout>
            </Route>
          </BookingProjectWrapper>
        </Route>
        <Route segment="admin">
          <Route segment="login" exact>
            <AdminLogin />
          </Route>
          <Route segment="logout" exact>
            <AdminLogout />
          </Route>
          <Route segment="register" exact>
            <AdminRegister />
          </Route>
          <Route segment="settings" exact>
            <AdminLayout>
              <AdminSettings />
            </AdminLayout>
          </Route>
          <Route segment="payment" exact>
            <AdminPayment />
          </Route>
          <Route segment="projects" exact>
            <AdminProjects />
          </Route>
          <Route segment="users" exact>
            <AdminUsers />
          </Route>
          <Route segment="updateConfigs" exact>
            <AdminUpdateConfigs />
          </Route>
          <Route segment="bookingforms">
            <AdminLayout>
              <Route segment="list" exact>
                <AdminBookingForms />
              </Route>
              <Route segment="edit">
                <AdminBookingFormLayout>
                  <Route segment="config" exact>
                    <AdminBookingFormConfig />
                  </Route>
                  <Route segment="welcomepage" exact>
                    <AdminBookingFormWelcomePage />
                  </Route>
                  <Route segment="embed" exact>
                    <AdminBookingFormEmbed />
                  </Route>
                  <Route segment="communication" exact>
                    <AdminBookingFormCommunication />
                  </Route>
                  <Route segment="calendar" exact>
                    <AdminBookingFormCalendar />
                  </Route>
                  <Route segment="slot" exact>
                    <AdminBookingFormSlot />
                  </Route>
                  <Route segment="booking" exact>
                    <AdminBookingFormBooking />
                  </Route>
                  <Route segment="search" exact>
                    <AdminBookingFormSearch />
                  </Route>
                  <Route segment="schedule" exact>
                    <AdminBookingFormSchedule />
                  </Route>
                </AdminBookingFormLayout>
              </Route>
            </AdminLayout>
          </Route>
        </Route>
      </Layout>
    </RouteContext.Provider>
  )
}

export default Router